import { getCurrentAppBrand } from '.'

/*
  Dans ce fichier, la première locale définie est la locale par défaut, pour la langue et le pays

  Exemple: si le brand est 'countrymalt', la langue par défaut sera "en" et le pays par défaut sera "US"
*/

export function chooseBrandLang(currentAppBrand: string) {
  switch (currentAppBrand) {
    case 'farmi':
      return ['fr-FR']
    case 'episens':
      return ['fr-FR']
    case 'aladin':
      return ['fr-FR']
    case 'countrymalt':
      return ['en-US', 'en-CA', 'fr-CA']
    default:
      return ['fr-FR']
  }
}

export function defaultBrandLang() {
  return chooseBrandLang(getCurrentAppBrand())[0]
}

export function currentBrandCountriesAndLang() {
  return chooseBrandLang(getCurrentAppBrand()).map((lang) => {
    return {
      lang: lang.split('-')[0].toLowerCase(),
      country: lang.split('-')[1].toLowerCase(),
    }
  })
}
